import React from 'react'
import { View } from 'react-native'
import { buttonsStyles } from '../Button/boutonStyle'
import { formsStyles } from '../Inputs/formStyles'
import Label from '../Label'

export const Separator = () => {

    return (
        <View style={buttonsStyles.displayCenterLoginBottom}>
            <View style={[buttonsStyles.displaySpacedBtween]}>
                <View style={formsStyles.line} />
                <View style={{ width: 8, justifyContent: 'center' }}>
                    <Label title="-" type="paragraph" />
                </View>
                <View style={formsStyles.line} />
            </View>
        </View>
    )
};
